module.exports = __webpack_public_path__ + "img/hr-garballo-04.3f92dffd.png";